import { useState } from "react";
import { api } from "../api";

export default function Login({ onSignedIn }: { onSignedIn: () => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.login(username, password);
      onSignedIn();
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="brand"><img src="/favicon.svg" alt="" /><span>gentiK</span></div>
        <h1>Sign in</h1>
        <p className="muted small" style={{ margin: 0 }}>
          Use your gentiK account. This is separate from your Kinaxis login.
        </p>
        <label className="field">
          <span>Username</span>
          <input className="input" autoComplete="username" value={username} autoFocus
                 onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label className="field">
          <span>Password</span>
          <input className="input" type="password" autoComplete="current-password" value={password}
                 onChange={(e) => setPassword(e.target.value)} />
        </label>
        {error && <div className="error-text small" role="alert">{error}</div>}
        <button className="btn primary" type="submit" disabled={busy || !username || !password}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
